import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Field, reduxForm, InjectedFormProps} from 'redux-form';
import ReduxFormInput from '../../../shared/components/ReduxFormHandlers/ReduxFormInput';
import { connect, useSelector } from 'react-redux';
import IState from '../../../core/models/IState';
import LoaderButton from '../../../shared/components/Button/LoaderButton';
import { validateEndDateRequiredIfStartDate, validateIAQICCIDAddSensor, validateIAQICCIDMaxLength, validateIAQICCIDMaxLengthAddSensor, validateLatestPayloadEndDateGreaterOrEqualRequired, validateMaxLength, validateMaxLengthSensorFilter, validateRequired, validateStartDateRequiredIfEndDate } from '../../../helpers/validation.helper';
import { FormattedMessage } from 'react-intl';
import { getFilterSensorSelector } from '../../../core/selectors/sensor.selector';
import { IOption } from '../../../models/IReduxFormHandlers';
import ReduxFormSelect from '../../../shared/components/ReduxFormHandlers/ReduxFormSelect';
import './AddSensorFilterForm.css';
import { formatMessage } from '../../../translations/connectedIntlProvider';
import DateTimeCustomPicker from '../../../shared/components/DateTimeWidget/DateTimeCustomWidget';

interface IProps {
    id: number;
    isDelete: boolean;
    submitHandler: (data: any) => void;
    onModalClosed: () => void;
    onClearFilter: () => void;
    getSensorLoading: boolean;
    userList: Array<IOption>;
    sensorTypeList: IOption[];
}

const AddSensorFilterForm: React.FC<InjectedFormProps<any, IProps> & IProps> = (props: any) => {
    const userType : any = useSelector((state: IState) => {return state.auth.userType});
    return (
        <Modal className="add-user-modal device-pop-up add-sensor-filter-form" show={true} centered onHidee={props.onClearFilter}
            onHide={props.onModalClosed}>
            <Modal.Header closeButton>
                <Modal.Title>

                    <FormattedMessage id='Sensor_Title_Filter' />

                </Modal.Title>
                {/*   {props.getSensorLoading ? <PageLoader /> : null} */}
            </Modal.Header>

            <form onSubmit={props.handleSubmit((values: any) => props.submitHandler(values))} noValidate>
                <Modal.Body>
                    <div className="form-group row">
                        <label className="label-style"><FormattedMessage id='Sensor_Label_ICCID' /></label>

                        <Field
                            className="form-control"
                            name="ICCID"
                            component={ReduxFormInput}
                            type="text"
                            max={150}
                            validate={[
                                // validateIAQICCID("Validation_ICCID_Alphanumeric"),
                                validateIAQICCIDAddSensor("Validation_ICCID_Numeric"),
                                validateIAQICCIDMaxLengthAddSensor(20,"Validation_ICCID_Max_20"),
                                // validateMaxLengthSensorFilter(20, 'Validation_ICCID_Max_Char')
                            ]}
                        />

                    </div>

                    <div className="form-group row">
                        <label className="label-style"><FormattedMessage id='Sensor_Label_CustomerId' /></label>
                        <Field
                            className="form-control"
                            name="CustomerId"
                            component={ReduxFormInput}
                            type="text"
                            max={150}
                            validate={[
                                validateMaxLength(150, 'Validation_CustomerId_Max_Char')]}
                        />

                    </div>

                    {/* <div className="form-group row">
                        <label className="label-style"><FormattedMessage id='Sensor_type' /></label>
                        <Field
                            className="form-control"
                            name="SensorType"
                            component={ReduxFormSelect}
                            isFormatMessage={true}
                            options={props.sensorTypeList}
                            type="text"
                            validate={[]}
                        />
                    </div> */}

                    <div className="form-group row">
                        <label className="label-style"><FormattedMessage id='Sensor_Label_Building' /></label>
                        <Field
                            className="form-control"
                            name="Building"
                            component={ReduxFormInput}
                            type="text"
                            max={150}
                            validate={[
                                validateMaxLength(150, 'Validation_Building_Max_Char')]}
                        />

                    </div>

                    <div className="form-group row">
                        <label className="label-style"><FormattedMessage id='Sensor_Label_Floor' /></label>

                        <Field
                            className="form-control"
                            name="Floor"
                            component={ReduxFormInput}
                            type="text"
                            min={3}
                            max={150}
                            validate={[
                                validateMaxLength(150, 'Validation_Floor_Max_Char')]}
                        />

                    </div>

                    <div className="form-group row">
                        <label className="label-style"><FormattedMessage id='Sensor_Label_Room' /></label>
                        <Field
                            className="form-control"
                            name="Room"
                            component={ReduxFormInput}
                            type="text"
                            min={3}
                            max={150}
                            validate={[
                                validateMaxLength(150, 'Validation_Room_Max_Char')]}
                        />

                    </div>

                    <div className="form-group row">
                        <label className="label-style"><FormattedMessage id='Sensor_Label_Location' /></label>

                        <Field
                            className="form-control"
                            name="Location"
                            component={ReduxFormInput}
                            type="text"
                            min={3}
                            max={150}
                            validate={[
                                validateMaxLength(150, 'Validation_Location_Max_Char')]}
                        />

                    </div>
                    <div className="row" >
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="label-style"><FormattedMessage id='Latest_Payload_Start_Date' /></label>
                                <Field
                                    className="form-control"
                                    name="LatestPayloadStartDateTime"
                                    component={DateTimeCustomPicker}
                                    validate={[validateStartDateRequiredIfEndDate("Validation_Required_StartDate")]}
                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="label-style"><FormattedMessage id='Latest_Payload_End_Date' /></label>
                                <Field
                                    className="form-control"
                                    name="LatestPayloadEndDateTime"
                                    placeholder={formatMessage("End_Date")}
                                    component={DateTimeCustomPicker}
                                    validate={[
                                        validateEndDateRequiredIfStartDate("Validation_Required_EndDate"),
                                        validateLatestPayloadEndDateGreaterOrEqualRequired("EndDate_Time_Greater_Required")
                                    ]
                                }
                                />
                            </div>
                        </div>
                    </div>

                    {   userType === 'Administrator' &&
                        <div className="form-group row">
                        <label className="label-style"><FormattedMessage id='Sensor_Label_User' /></label>
                        <Field
                            className="form-control"
                            name="UserId"
                            component={ReduxFormSelect}
                            options={props.userList}
                            type="text"
                            validate={[]}
                        />
                    </div>
                    }

                </Modal.Body>

                <div className="modal-footer">
                    <div className="form-group row tab-action">
                        <div className="col-12 px-0 filter-btn">
                            <Button variant="primary float-left" onClick={props.onClearFilter}><FormattedMessage id='Button_Clear_Filter' /></Button>
                            <Button variant="primary" onClick={props.onModalClosed}><FormattedMessage id='Button_Cancel' /></Button>
                            <LoaderButton type="submit" text={"Sensor_Title_Filter"} />
                        </div>
                    </div>
                </div>
            </form>

        </Modal>
    )
}

//const selector = formValueSelector('AddSensorForm');

const mapStateToProps = (state: IState) => ({
    initialValues: getFilterSensorSelector(state),

});


const form = reduxForm<any, IProps>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    form: 'IAQSensorFilterForm',
    enableReinitialize: true,
    onSubmitFail: (errors: any) => {
        //toast.error(formatMessage('Validation_Correct_error'));
    }
})(AddSensorFilterForm);


export default connect(mapStateToProps)(form);
